import React from 'react'
import styles from "./block7.module.css"
import stylesblk4 from "../schoolRitualBlockFour/schoolRitualBlockFour.module.css";

import LazySection from '../LazySection'

function BlockSeven({ leoInvocationRef, virgoInvocationRef, libraInvocationRef, scorpioInvocationRef, sagittariusInvocationRef, capricornInvocationRef, aquarisInvocationRef, piscesInvocationRef,natalIncarnationRef }) {
  return (
    <>
      <div className={styles.school_ritual_horoscope_mainWrp}>
        <div className={styles.common_width}>

          <LazySection>
            <div
              className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} `}
            >


              <div className={styles.school_ritual_txt_box_wrpr}>

                <h2 ref={leoInvocationRef}>Leo Invocation (Fixed Fire)</h2>

                <div className={styles.school_ritual_txt_box_innr}>
                  <p>
                    Centering in Leo is about radiating creative energy with unwavering confidence. As a Fixed sign, Leo embodies consistent expression and unwavering self-belief. You focus on your inner radiance, your ability to lead with heart, and your joyful self-expression, maintaining a constant and powerful presence. It's about cultivating courage, generosity, and a sense of personal power, shining your light with steadfast brilliance. You visualize yourself as a radiant sun, shining your light upon the world with unyielding power.
                  </p>
                  <h3>Ritual Praxis of the Zodiacal House of Sun</h3>
                  <p>Once completing the opening of the gates of fire, staying still and centralized within the ritual space,
                    focusing on the infinite center of being and the spherical self boundary as the total immortal and infinite self, make the gesture of the Fixed Sun, and within the imaginal being see the sign of Leo ablaze in the center. Hold for one to three full breaths then make the pronouncement and resonate the Divine Name of the Zodiacal Sign.</p>

                  <p>Pronouncement: <span className={styles.dark_yellow}>"In nomine Leonis, personae domus Solis, ignis et splendoris."</span></p>
                  <p>Translation: <span className={styles.dark_yellow}>"In the name of Leo, personality of the House of the Sun, of fire and splendor."</span></p>

                  <p>Phonetics: <span className={styles.dark_yellow}>"In noh-mee-nay Lay-oh-nees, per-soh-ne doh-moos Soh-lees, ig-nees et splen-doh-rees."</span></p>

                  <p> <span className={styles.color_white}> Resonate Divine Name: </span> <span className={styles.dark_yellow}> Leo / Latin - Leo (LAY-oh) - LAYYYYYYY-ohhhhhh-ohhhhhhh </span> </p>

                  <p>Focus on the unity between the self and the self boundary as a total unity allowing the Solar House of Leo to possess and transform and bring the self into alignment.  Hold the sign of silence for at least three full breaths afterward focusing on being surrounded on every point by the solar intelligence of Leo. </p>
                </div>
              </div>

              <div className={styles.school_ritual_img_box_wrpr}>
                <img
                  className={styles.school_ritual_img1}
                  src="/image/leo_img_new.webp" alt='Image'
                />
              </div>
            </div>
          </LazySection>

          <LazySection>
            <div
              className={`${styles.school_ritual_virgo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
            >


              <div className={styles.school_ritual_txt_box_wrpr}>

                <h2 ref={virgoInvocationRef}>Virgo Invocation (Mutable Earth)</h2>

                <div className={styles.school_ritual_txt_box_innr}>
                  <p>
                    Centering in Virgo is about adapting your practical energy to serve and refine. As a Mutable sign, Virgo represents adaptability in practical matters. You focus on your attention to detail, your ability to
                    analyze and improve, and your desire to be of service, adjusting your efforts to meet the needs of the moment. It's about cultivating humility, practicality, and a sense of order, refining and perfecting the details. You visualize yourself as a clear, organized space, ready for productive work that is constantly being adjusted.
                  </p>
                  <h3>Ritual Praxis of the Zodiacal House of Sun</h3>
                  <p>Once completing the opening of the gates of earth, staying still and centralized within the ritual space, focusing on the infinite center of being and the spherical self boundary as the total immortal and infinite self, make the gesture of the Mutable Sun, and within the imaginal being see the sign of Virgo ablaze in the center. Hold for one to three full breaths then make the pronouncement and
                    resonate the Divine Name of the Zodiacal Sign.</p>

                  <p>Pronouncement: <span className={styles.dark_yellow}>"In nomine Virginis, personae domus Solis, terrae et perfectionis."</span></p>
                  <p>Translation: <span className={styles.dark_yellow}>"In the name of Virgo, personality of the House of the Sun, of earth and perfection."</span></p>

                  <p>Phonetics: <span className={styles.dark_yellow}>"In noh-mee-nay Veer-jee-nees, per-soh-ne doh-moos Soh-lees, ter-re et per-feh-tee-oh-nees."</span></p>

                  <p><span className={styles.color_white}>Resonate Divine Name:</span> <span className={styles.dark_yellow}>Virgo / Latin - Virgo (VEER-goh) - VEEEEEEE-errrrrr-gohhhhhhh</span></p>

                  <p>Focus on the unity between the self and the self boundary as a total unity allowing the Solar House of Virgo to possess and transform and bring the self into alignment.  Hold the sign of silence for at least three full breaths afterward focusing on being surrounded on every point by the solar intelligence of Virgo. </p>
                </div>
              </div>

              <div className={styles.school_ritual_img_box_wrpr}>
                <img
                  className={styles.school_ritual_img1}
                  src="/image/virgo_img_new.webp" alt='Image'
                />
              </div>
            </div>
          </LazySection>

          <LazySection>
            <div
              className={`${styles.school_ritual_libra_wrpr} ${styles.flx_wrpr} `}
            >


              <div className={styles.school_ritual_txt_box_wrpr}>

                <h2 ref={libraInvocationRef}>Libra Invocation (Cardinal Air)</h2>

                <div className={styles.school_ritual_txt_box_innr}>
                  <p>
                    Centering in Libra is about initiating harmonious connections and balance. As a Cardinal sign, Libra represents the beginning of relationships. You focus on your sense of fairness, your ability to create peaceful interactions, and your appreciation for beauty, initiating connections and establishing equilibrium. It's about cultivating diplomacy, cooperation, and a sense of equilibrium, bringing balance to all interactions. You visualize yourself as a perfectly balanced scale, initiating harmony.

                  </p>
                  <h3>Ritual Praxis of the Zodiacal House of Sun</h3>
                  <p>Once completing the opening of the gates of air, staying still and centralized within the ritual space, focusing on the infinite center of being and the spherical self boundary as the total immortal and infinite self, make the gesture of the Mutable Sun, and within the imaginal being see the sign of Libra ablaze in the center. Hold for one to three full breaths then make the pronouncement and resonate the Divine Name of the Zodiacal Sign.</p>

                  <p>Pronouncement: <span className={styles.dark_yellow}>"In nomine Librae, personae domus Solis, aeris et aequilibrii."</span>
                  </p>
                  <p>Translation: <span className={styles.dark_yellow}>"In the name of Libra, personality of the House of the Sun, of air and equilibrium."</span></p>

                  <p>Phonetics: <span className={styles.dark_yellow}>"In noh-mee-nay Lee-bre, per-soh-ne doh-moos Soh-lees, ah-air-ees et ah-kwee-lee-bree-ee."</span></p>

                  <p><span className={styles.color_white}>Resonate Divine Name:</span> <span className={styles.dark_yellow}> Libra / Latin - Libra (LEE-brah) - LIIIIIII-brahhhhh-ahhhhhhh</span></p>

                  <p>Focus on the unity between the self and the self boundary as a total unity allowing the Solar House of Libra to possess and transform and bring the self into alignment.  Hold the sign of silence for at least three full breaths afterward focusing on being surrounded on every point by the solar intelligence of Libra.</p>
                </div>
              </div>

              <div className={styles.school_ritual_img_box_wrpr}>
                <img
                  className={styles.school_ritual_img1}
                  src="/image/libra_img_new.webp" alt='Image'
                />
              </div>
            </div>
          </LazySection>

          <LazySection>
            <div
              className={`${styles.school_ritual_scorpio_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
            >


              <div className={styles.school_ritual_txt_box_wrpr}>

                <h2 ref={scorpioInvocationRef}>Scorpio Invocation (Fixed Water)</h2>

                <div className={styles.school_ritual_txt_box_innr}>
                  <p>
                    Centering in Scorpio is about holding transformative emotional energy with unwavering intensity. As a Fixed sign, Scorpio embodies deep, unwavering emotional power. You focus on your inner power, your ability to delve into the depths of your psyche, and your capacity for profound change, holding firm to your transformative intent. It's about cultivating courage, resilience, and a sense of mystery, maintaining an intense focus on inner transformation. You visualize yourself as a phoenix, rising from the ashes with unyielding power.

                  </p>
                  <h3>Ritual Praxis of the Zodiacal House of Sun
                  </h3>
                  <p>Once completing the opening of the gates of water, staying still and centralized within the ritual space, focusing on the infinite center of being and the spherical self boundary as the total immortal and infinite self, make the gesture of the Fixed Sun, and within the imaginal being see the sign of Scorpio ablaze in the center. Hold for one to three full breaths then make the pronouncement and resonate the Divine Name of the Zodiacal Sign.</p>

                  <p>Pronouncement:  <span className={styles.dark_yellow}>"In nomine Scorpionis, personae domus Solis, aquae et transformationis profundae."</span>

                  </p>
                  <p>Translation: <span className={styles.dark_yellow}>"In the name of Scorpio, personality of the House of the Sun, of water and profound transformation."</span></p>

                  <p>Phonetics: <span className={styles.dark_yellow}>"In noh-mee-nay Skor-pee-oh-nees, per-soh-ne doh-moos Soh-lees, ah-kwee et trahn-sfohr-mah-tee-oh-nees pro-foon-de."</span></p>

                  <p><span className={styles.color_white}>Resonate Divine Name:</span> <span className={styles.dark_yellow}> Scorpio / Latin - Scorpio (SKOR-pee-oh) - SKORRRRRR-peeeeeee-ohhhhhhh</span></p>

                  <p>Focus on the unity between the self and the self boundary as a total unity allowing the Solar House of Scorpio to possess and transform and bring the self into alignment.  Hold the sign of silence for at least three full breaths afterward focusing on being surrounded on every point by the solar
                    intelligence of Scorpio.</p>
                </div>
              </div>

              <div className={styles.school_ritual_img_box_wrpr}>
                <img
                  className={styles.school_ritual_img1}
                  src="/image/scorpio_img_new.webp" alt='Image'
                />
              </div>
            </div>
          </LazySection>

          <LazySection>
            <div
              className={`${styles.school_ritual_saggiratus_wrpr} ${styles.flx_wrpr}`}
            >


              <div className={styles.school_ritual_txt_box_wrpr}>

                <h2 ref={sagittariusInvocationRef}>Sagittarius Invocation (Mutable Fire)</h2>

                <div className={styles.school_ritual_txt_box_innr}>
                  <p>
                    Centering in Sagittarius is about adapting your expansive energy to seek wisdom. As a Mutable sign, Sagittarius represents adaptability in philosophical pursuits. You focus on your sense of adventure, your desire for knowledge, and your optimistic outlook, adjusting your path to pursue higher understanding. It's about cultivating freedom, enthusiasm, and a sense of purpose, allowing your beliefs to evolve. You visualize yourself as an archer, aiming your arrow towards the horizon, adjusting your aim as needed.

                  </p>
                  <h3>Ritual Praxis of the Zodiacal House of Sun
                  </h3>
                  <p>Once completing the opening of the gates of fire, staying still and centralized within the ritual space, focusing on the infinite center of being and the spherical self boundary as the total immortal and infinite self, make the gesture of the Mutable Sun, and within the imaginal being see the sign of Sagittarius ablaze in the center. Hold for one to three full breaths then make the pronouncement and resonate the Divine Name of the Zodiacal Sign.</p>

                  <p>Pronouncement: <span className={styles.dark_yellow}>"In nomine Sagittarii, personae domus Solis, ignis et sapientiae." </span> </p>
                  <p>Translation: <span className={styles.dark_yellow}>"In the name of Sagittarius, personality of the House of the Sun, of fire and wisdom."</span></p>

                  <p>Phonetics: <span className={styles.dark_yellow}>"In noh-mee-nay Sah-gee-tah-ree-ee, per-soh-ne doh-moos Soh-lees, ig-nees et sah-pee-en-tee-e."</span></p>

                  <p><span className={styles.color_white}>Resonate Divine Name:</span> <span className={styles.dark_yellow}> Sagittarius / Latin - Sagittarius (Sah-gee-TAH-ree-us) - Sahhhhhhh-gee-tahhhhhh-reee-usssssss</span></p>

                  <p>Focus on the unity between the self and the self boundary as a total unity allowing the Solar House of Sagittarius to possess and transform and bring the self into alignment. Hold the sign of silence for at least three full breaths afterward focusing on being surrounded on every point by the solar intelligence of Sagittarius.</p>
                </div>
              </div>

              <div className={styles.school_ritual_img_box_wrpr}>
                <img
                  className={styles.school_ritual_img1}
                  src="/image/saggiratus_img_new.webp" alt='Image'
                />
              </div>
            </div>
          </LazySection>


          <LazySection>
            <div
              className={`${styles.school_ritual_capricorn_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
            >


              <div className={styles.school_ritual_txt_box_wrpr}>

                <h2 ref={capricornInvocationRef}>Capricorn Invocation (Cardinal Earth)</h2>

                <div className={styles.school_ritual_txt_box_innr}>
                  <p>
                    Centering in Capricorn is about initiating structured and disciplined earth energy. As a Cardinal sign, Capricorn represents the beginning of structure and achievement. You focus on your ambition, your ability to create structure, and your dedication to your goals, initiating projects and establishing solid foundations. It's about cultivating patience, perseverance, and a sense of responsibility, building stable structures. You visualize yourself as a strong, solid mountain, initiating a climb.</p>
                  <h3>Ritual Praxis of the Zodiacal House of Sun
                  </h3>
                  <p>Once completing the opening of the gates of earth, staying still and centralized within the ritual space, focusing on the infinite center of being and the spherical self boundary as the total immortal and infinite self, make the gesture of the Cardinal Sun, and within the imaginal being see the sign of Capricorn ablaze in the center. Hold for one to three full breaths then make the pronouncement and resonate the Divine Name of the Zodiacal Sign.</p>

                  <p>Pronouncement: <span className={styles.dark_yellow}>"In nomine Capricorni, personae domus Solis, terrae et structurae."</span>
                  </p>
                  <p>Translation: <span className={styles.dark_yellow}>"In the name of Capricorn, personality of the House of the Sun, of earth and structure."</span></p>

                  <p>Phonetics:  <span className={styles.dark_yellow}>"In noh-mee-nay Kah-pree-kor-nee, per-soh-ne doh-moos Soh-lees, ter-re et strook-too-re." </span>
                  </p>

                  <p><span className={styles.color_white}>Resonate Divine Name:</span> <span className={styles.dark_yellow}> Capricorn / Latin - Capricornus (Kah-pree-KOR-nus) - Kahhhhhhh-preeeeeee-korrrrr-nusssssss</span></p>

                  <p>Focus on the unity between the self and the self boundary as a total unity allowing the Solar House of Capricorn to possess and transform and bring the self into alignment.  Hold the sign of silence for at least three full breaths afterward focusing on being surrounded on every point by the solar
                    intelligence of Capricorn.</p>
                </div>
              </div>

              <div className={styles.school_ritual_img_box_wrpr}>
                <img
                  className={styles.school_ritual_img1}
                  src="/image/capricorn_img_new.webp" alt='Image'
                />
              </div>
            </div>
          </LazySection>

          <LazySection>
            <div
              className={`${styles.school_ritual_aquarius_wrpr} ${styles.flx_wrpr} `}
            >


              <div className={styles.school_ritual_txt_box_wrpr}>

                <h2 ref={aquarisInvocationRef}>Aquarius Invocation (Fixed Air)</h2>

                <div className={styles.school_ritual_txt_box_innr}>
                  <p>
                    Centering in Aquarius is about holding innovative and free thinking air energy with unwavering conviction. As a Fixed sign, Aquarius embodies consistent, unwavering ideals. You focus on your originality, your humanitarian spirit, and your desire for social change, maintaining a firm belief in your ideals. It's about cultivating open-mindedness, independence, and a sense of community, holding firm to your visionary ideals. You visualize yourself as a network of interconnected ideas, firmly established.</p>
                  <h3>Ritual Praxis of the Zodiacal House of Sun
                  </h3>
                  <p>Once completing the opening of the gates of air, staying still and centralized within the ritual space, focusing on the infinite center of being and the spherical self boundary as the total immortal and infinite self, make the gesture of the Fixed Sun, and within the imaginal being see the sign of Aquarius ablaze in the center. Hold for one to three full breaths then make the pronouncement and resonate the Divine Name of the Zodiacal Sign.</p>

                  <p>Pronouncement: <span className={styles.dark_yellow}>"In nomine Aquarii, personae domus Solis, aeris et libertatis."</span></p>
                  <p>Translation: <span className={styles.dark_yellow}>"In the name of Aquarius, personality of the House of the Sun, of air and freedom."</span>
                  </p>

                  <p>Phonetics: <span className={styles.dark_yellow}>"In noh-mee-nay Ah-kwa-ree-ee, per-soh-ne doh-moos Soh-lees, ah-air-ees et lee-ber-tah-tees."</span></p>

                  <p><span className={styles.color_white}>Resonate Divine Name:</span> <span className={styles.dark_yellow}>  Aquarius / Latin - Aquarius (Ah-KWAH-ree-us) - Ahhhhhhh-kwahhhhhh-reee-usssssss</span></p>

                  <p>Focus on the unity between the self and the self boundary as a total unity allowing the Solar House of Aquarius to possess and transform and bring the self into alignment.  Hold the sign of silence for at least three full breaths afterward focusing on being surrounded on every point by the solar intelligence of Aquarius.</p>
                </div>
              </div>

              <div className={styles.school_ritual_img_box_wrpr}>
                <img
                  className={styles.school_ritual_img1}
                  src="/image/Aquarius_img_new.webp" alt='Image'
                />
              </div>
            </div>
          </LazySection>

          <LazySection>
            <div
              className={`${styles.school_ritual_pisces_wrpr} ${styles.flx_wrpr}  ${styles.flx_row}`}
            >


              <div className={styles.school_ritual_txt_box_wrpr}>

                <h2 ref={piscesInvocationRef}>Pisces Invocation (Mutable Water)</h2>

                <div className={styles.school_ritual_txt_box_innr}>
                  <p>
                    Centering in Pisces is about adapting your compassionate water energy to flow with spiritual connection. As a Mutable sign, Pisces represents adaptability in spiritual matters. You focus on your intuition, your connection to the divine, and your ability to transcend the material world, adjusting your awareness to flow with spiritual currents. It's about cultivating empathy, forgiveness, and a sense of oneness, allowing your compassion to adapt. You visualize yourself as a vast, boundless ocean, constantly shifting.</p>
                  <h3>Ritual Praxis of the Zodiacal House of Sun </h3>
                  <p>Once completing the opening of the gates of water, staying still and centralized within the ritual space, focusing on the infinite center of being and the spherical self boundary as the total immortal and infinite self, make the gesture of the Muteable Sun, and within the imaginal being see the sign of Pieces ablaze in the center. Hold for one to three full breaths then make the pronouncement and resonate the Divine Name of the Zodiacal Sign.
                  </p>

                  <p>Pronouncement: <span className={styles.dark_yellow}>"In nomine Piscium, personae domus Solis, aquae et compassionis."</span>
                  </p>
                  <p>Translation: <span className={styles.dark_yellow}>"In the name of Pisces, personality of the House of the Sun, of water and compassion." </span>
                  </p>

                  <p>Phonetics: <span className={styles.dark_yellow}>"In noh-mee-nay Pee-shee-oom, per-soh-ne doh-moos Soh-lees, ah-kwee et kom-pah-see-oh-nees."</span></p>

                  <p><span className={styles.color_white}>Resonate Divine Name:</span> <span className={styles.dark_yellow}> Pisces / Latin - Pisces (PEE-skays) - PEEEEEEE-skayyyyyy-essssssss </span></p>

                  <p>Focus on the unity between the self and the self boundary as a total unity allowing the Solar House of Pieces to possess and transform and bring the self into alignment. Hold the sign of silence for at least three full breaths afterward focusing on being surrounded on every point by the solar
                    intelligence of Pieces.</p>
                </div>
              </div>

              <div className={styles.school_ritual_img_box_wrpr}>
                <img
                  className={styles.school_ritual_img1}
                  src="/image/Pisces_img_new.webp" alt='Image'
                />

                <img
                  className={styles.pisces_grad_color}
                  src="/image/Pisces_img_new.webp" alt='Image'
                />
              </div>
            </div>
          </LazySection>



          {/* ---------------------------block20-------------------  */}





          <LazySection>
            <div
              className={`${stylesblk4.school_ritual_horoscope_mainWrp} ${stylesblk4.school_ritual_psd4_block20_mainWrp}`}
            >
              <div className={stylesblk4.common_width}>
                <div className={stylesblk4.column} ref={natalIncarnationRef}>
                  <div className={`${stylesblk4.col12} ${stylesblk4.bgifive}`}>
                    <h2>
                      Astrological Theurgy and the Natal Incarnation of Theurgic
                      Union
                    </h2>
                  </div>
                </div>

                <div
                  className={`${stylesblk4.school_ritual_leo_wrpr} ${stylesblk4.flx_wrpr} ${stylesblk4.flx_row}`}
                >
                  <div className={stylesblk4.school_ritual_txt_box_wrpr}>
                    <div className={stylesblk4.school_ritual_txt_box_innr}>

                      <h2>The Natal Blueprint Invocation (Solar Return Praxis)</h2>
                      <p>This step marks the capstone of the foundational cycle—the moment when all the planetary and zodiacal currents you have invoked, purified, and aligned in prior work are gathered into the singular, unrepeatable pattern of your incarnation. Here, the work turns inward, from the great vault of heaven to the intimate architecture of your own being, drawing them home into the form and function of your oikeios daimon—the personal, immortal pattern that shapes your destiny in this life.</p>

                      <p>In this operation, you ritually reanimate the heavens exactly as they stood at the moment of your birth, sealing their arrangement into conscious embodiment—the living operation of the chart, a direct act of theurgy in which the gods, signs, and angles of your nativity are called forth to take their rightful stations within your soul’s temple.</p>

                      <p>All of the ritual technology required for this working is expressed through the Celestial Ritual of the Pentagram, whose flexible structure allows the theurgist to open the gates to both planetary and zodiacal intelligences in the precise sequence of their natal sky. This rite transforms the chart from a static diagram into an active, breathing engine of divine presence, harmonizing the macrocosm of the heavens with the microcosm of the incarnate self. It becomes the first step in ritual encounter with the living blueprint of destiny through dynamic theurgic union, marking the official call of the <span>“guardian spirit” (oikeios daimōn)</span>. While the divine double—Protogonos—is invoked each time in the Grand Invocation, it is here that ritual begins to bond the persona of the immortal manifold through which we were born with the awakened presence of the daemon. In this way, the direct awareness of the blueprint is stirred into life within the theurgist, activating their participation in its unfolding.</p>
                      {/* <h3> What Changes at This Step</h3> */}
                      <p>You shift from working powers in their abstract stations to working them in the <span>exact natal configuration</span>. The rite installs your cosmic seal as a living motor within the microcosm, so the year ahead runs on the pattern you consciously enthrone rather than on unconscious momentum.</p>



                      {/* <p>
                      Astrological Theurgy is a sacred art founded upon the
                      recognition that the visible cosmos is not a backdrop to
                      human experience, but a radiant, ensouled manifestation of
                      divine intelligence. In this path, we do not treat the
                      planetary bodies as inert vessels merely interpenetrated
                      by spiritual forces. Rather, we behold them as fully
                      realized divine beings—trans-conscious intelligences who
                      appear to us in their glory as the radiant gods of the
                      heavens. These are not metaphorical constructs, nor
                      psychological symbols, nor abstract archetypes. They are
                      immense beings of presence, magnitude, and meaning,
                      concretely arrayed in the starry vault above, whose
                      celestial rhythms and luminous geometries shape the very
                      conditions of our incarnation.
                    </p>

                    <p>
                      We understand the stars and planets as living participants
                      in the divine unfolding of the cosmos—each one expressing
                      a particular note in the great symphony of creation. The
                      zodiac, likewise, is not a static belt of symbols but the
                      twelvefold articulation of the Solar Logos—a radiant
                      ordering principle that refracts the one light of divine
                      will into differentiated qualities of being. In this view,
                      the planets are the forces of the gods, and the signs are
                      their cosmic postures—their attunements, their
                      personalities, their masks and songs.
                    </p>

                    <p>
                      Astrological Theurgy thus becomes a ritual and
                      contemplative method of aligning oneself with the divine
                      blueprint of incarnation—not as an act of passive
                      acceptance, but as a conscious co-participation in the
                      cosmos. Through ritual purification, invocation, and
                      meditative attunement, the theurgist gradually harmonizes
                      with the sacred pattern that governs both the heavens and
                      the soul. This is a path not merely of insight, but of
                      integration—the embodiment of the macrocosmic order within
                      the microcosmic temple of the self.
                    </p>
                    <p>
                      We strongly recommend that the serious practitioner
                      undergo our 15-month mystery school curriculum before
                      formally entering Phase III of this work. The first two
                      phases of the ritual framework are covered in depth in
                      this program, alongside our unique ritual praxis across
                      the zodiacal decans, which offers a concentrated
                      engagement with the twelve signs through their threefold
                      expressions. This structured initiation lays the
                      foundation for theurgic maturity and supports the deep
                      internal transformation required to carry the natal
                      invocation with clarity and power.
                    </p>
                    <p>
                      That said, the entire framework of Astrological Theurgy
                      may be entered at any time. While full initiatory training
                      strengthens the vessel, the divine intelligences are ever
                      present, and even the first steps taken with sincerity can
                      resonate deeply. What follows is a comprehensive
                      articulation of the ritual sequence—a map of theurgic
                      re-alignment through the living sky.
                    </p> */}
                    </div>
                  </div>

                  <div className={stylesblk4.school_ritual_img_box_wrpr}>
                    <img
                      className={stylesblk4.school_ritual_img1}
                      src="/image/school_ritual_psd4_block23_mainWrp_bg_20aug_new_updated.webp"
                      alt="Image"
                    />
                  </div>
                </div>
              </div>
            </div>
          </LazySection>

          {/* ---------------------------block21-------------------  */}

          <LazySection>
            <div
              className={`${stylesblk4.school_ritual_horoscope_mainWrp} ${stylesblk4.school_ritual_psd4_block21_mainWrp}`}
            >
              <div className={stylesblk4.common_width}>
                <div
                  className={`${stylesblk4.school_ritual_leo_wrpr} ${stylesblk4.flx_wrpr} ${stylesblk4.flx_row}`}
                >
                  <div className={stylesblk4.school_ritual_txt_box_wrpr}>
                    <div className={stylesblk4.school_ritual_txt_box_innr}>

                      <h2>Preparation ( 7 days before your birthday)</h2>
                      <p>The final week before your Solar Return is the threshold to the rite itself — a deliberate period of attunement in which you ready both the outer and inner temple for the work ahead. You want to prepare your psyche and understanding to actively align with your natal pattern so that, when the operational window opens, you enter already carrying the sequence, the names, and the gates to be opened within you. Each day’s review, each refinement of your invocation order, and each act of clearing is part of stepping into the ritual as a living extension of your own cosmic seal. Consider also performing a banishing for the planets that you feel out of sync with during this period.</p>
                      <h3>1) Assemble your natal brief.</h3>
                      <p>In your journal, hand-copy:</p>
                      <ul>
                        <li><strong>Each planet in its natal sign</strong> <span>(and house,to clarify the areas of life they influence)</span>.</li>
                        <li><strong>Ascendant</strong> <span>(rising sign)</span> and <strong>chart ruler</strong> <span>(planetary ruler of the Ascendant)</span>.</li>
                        <li><strong>House ruler</strong> for the Sun <span>(i.e., the planet that rules the sign on your Sun’s house cusp)</span>.</li>

                        <li><strong>Optional advanced:</strong> prime dignities <span>(domicile/exaltation)</span>, key <span>aspects</span> to be acknowledged in the call, and <span>active transits</span> you intend to weave during the window.</li>




                      </ul>
                      <h3>2) Compose your calls in working order.</h3>
                      <p> Rewrite every relevant invocation/pronouncement <span>in the sequence you will perform it for your nativity</span>. This is your personal liturgy. Keep it fluent—no paging between sources once you begin.</p>
                      <h3>3) Optional consult.</h3>
                      <p> Obtain a <span>Solar Return</span> reading. File the timing notes <span>(exact return, day/hour elections)</span> with your brief.</p>
                      {/* <h3>
                      Phase I: Banishment and Clarification of the Planetary
                      Forces
                    </h3>
                    <p>
                      Before any invocation may take place, we must first clear
                      the field. The planetary forces, though divine in essence,
                      are often experienced through the distortions of sublunar
                      embodiment—filtered through personal karma, collective
                      patterning, and unconscious complexes. Thus, we begin by
                      banishing—not as a rejection, but as a sacred
                      disentanglement.
                    </p>

                    <p>
                      Each planetary god is ritually banished in its lower
                      expression, the habitual or fragmented modes of operation
                      that arise when their powers are misaligned with the
                      soul’s divine intention. Through a structured rite—often
                      employing gesture, divine name, and directional
                      alignment—we purify the temple space of chaotic or
                      compulsive planetary residue.
                    </p>

                    <p>
                      Following this banishment, we invoke the clarified,
                      elevated form of each planetary intelligence, not in
                      abstraction but through their precise energetic
                      signatures. Jupiter is not merely <span>“expansion,”</span> but becomes
                      the Logos of Divine Providence; Mars, in his higher form,
                      is not conflict, but Holy Courage—the upsurge of divine
                      assertion rightly ordered. Venus becomes the harmonizer of
                      soul-affinities; Saturn, the guardian of form and
                      spiritual gravity; Mercury, the divine interpreter and
                      alchemical messenger. Each is called into presence,
                      reestablished in their sacred role as gods who serve the
                      unfolding of the divine within the incarnate world.
                    </p> */}
                    </div>
                  </div>

                  <div className={stylesblk4.school_ritual_img_box_wrpr}>
                    <img
                      className={stylesblk4.school_ritual_img1}
                      src="/image/school_ritual_psd4_block21_mainWrp_bg_19aug.webp"
                      alt="Image"
                    />
                  </div>
                </div>
              </div>
            </div>
          </LazySection>

          {/* ---------------------------block22-------------------  */}

          <LazySection>
            <div
              className={`${stylesblk4.school_ritual_horoscope_mainWrp} ${stylesblk4.school_ritual_psd4_block22_mainWrp}`}
            >
              <div className={stylesblk4.common_width}>
                <div
                  className={`${stylesblk4.school_ritual_leo_wrpr} ${stylesblk4.flx_wrpr} ${stylesblk4.flx_row}`}
                >
                  <div className={stylesblk4.school_ritual_txt_box_wrpr}>
                    <div className={stylesblk4.school_ritual_txt_box_innr}>
                      <h2>Timing (Operational Window)</h2>
                      <p>
                        This rite is anchored to a span of time when the heavens most clearly reflect the seal of your incarnation. It begins at your <span>Solar Return</span>—the precise moment the Sun returns to the exact degree and minute it held at your birth—and proceeds through a sequence of daily invocations. From that day forward, each station is called on successive days, ideally at the same hour, as you move step by step through your incarnate nativity. This liminal season is when your natal blueprint stands most unveiled, its channels most open, and its pattern most receptive to renewal and theurgic alignment.
                      </p>

                      {/* <p>
                      Approaching the rite within this narrow arc is not a matter of superstition, but of resonance. The Solar Return is the annual re-ignition of the cosmic imprint that shaped your entry into embodiment; within these days, the alignment can be deliberately rekindled. Theurgists who keep to this operational window find the natal invocation not only installs the pattern for the year ahead, but deepens its authority as a living force in their work.
                    </p>

                    <ul>
                      <li><span><strong>Open on your birthday:</strong></span> begin at or within the nearest practicable window of the <span><strong>exact Solar Return</strong> (Sun to natal degree)</span>.</li>
                      <li><span><strong>Close before the Sun changes sign:</strong></span> complete the sequence while the Sun remains in your natal sign.</li>
                    </ul>
                    <p> This liminal interval is the strongest yearly charge for re-enthroning the natal seal.</p> */}
                    </div>
                  </div>

                  <div className={stylesblk4.school_ritual_img_box_wrpr}>
                    <img
                      className={stylesblk4.school_ritual_img1}
                      src="/image/school_ritual_psd4_block22_mainWrp_bg_19aug.webp"
                      alt="Image"
                    />
                  </div>
                </div>
              </div>
            </div>
          </LazySection>

          {/* ---------------------------block23-------------------  */}

          <LazySection>
            <div
              className={`${stylesblk4.school_ritual_horoscope_mainWrp} ${stylesblk4.school_ritual_psd4_block23_mainWrp}`}
            >
              <div className={stylesblk4.common_width}>
                <div
                  className={`${stylesblk4.school_ritual_leo_wrpr} ${stylesblk4.flx_wrpr} ${stylesblk4.flx_row}`}
                >
                  <div className={stylesblk4.school_ritual_txt_box_wrpr}>
                    <div className={stylesblk4.school_ritual_txt_box_innr}>
                      <h2>Daily Ritual Sequence (Multi-Day Working)</h2>
                      <p>
                        Each day is a complete operation: <span>Banishing</span> → <span>Opening of the Gates</span> → <span>Invocations</span> → <span>Closing</span>.
                      </p>
                      <h3>Day One</h3>

                      <p>
                        The first day establishes the axis of identity and vitality. Begin by performing the <span>Theurgic Ritual of the Pentagram</span> in your established form, cleansing and orienting the working space. Then open the gates in sequence, following the elemental gate rules given above and the order set forth in the Celestial Pentagram. Invoke first the Sun <span>(planetary)</span>, and then your Sun sign <span>(zodiacal)</span>, maintaining their proper sequence. These invocations set the tone for the entire cycle, rooting the work in the pattern of your life-force and the horizon of your personal being.
                      </p>



                      {/* <ul>
                      <li>Perform <span>The Theurgic Ritual of the Pentagram (your established form)</span>.</li>
                      <li><span>Opening of the Gates</span> for the <span>Sun</span> and your <span>Ascendant (elemental gates as required; see gate rules below)</span>.</li>
                      <li>Invoke <span>your Sun sign (zodiacal)</span> and <span>your Sun (planetary)</span> in proper sequence, then <span>your Ascendant</span> and <span>chart ruler</span>.</li>
                      <li>Close with your standard seal <span>(Resonate Divine Name and Sign of Silence)</span>.</li>
                    </ul> */}
                      <h3>Day Two</h3>
                      <p>The second day establishes the axis of emergence and personal horizon. Begin once more with the <span>Theurgic Ritual of the Pentagram</span>, aligning and consecrating the working space. Open the gates in sequence according to the elemental rules and the order of the Celestial Pentagram. Invoke first the planet that rules your Ascendant <span>(the chart ruler)</span>, and then the Ascendant sign itself. These invocations awaken the horizon of your incarnation and the guiding principle that shapes its expression, anchoring the cycle in the living thread between your embodied presence and the intelligence that directs its unfolding.</p>
                      {/* <ul>
                      <li>TRP → <span>Open gates</span> as required → Invoke <span>the ruler of the Sun’s house (the planet that rules the sign on the Sun’s house cusp)</span>.</li>
                      <li>If you are including <span>angles</span>, you may acknowledge MC/DC/IC by name and ruler <span>(brief calls; keep primary focus on the day’s anchor)</span>.</li></ul> */}

                      <h3>Day Three</h3>
                      <p>The third day establishes the axis of power and placement. Begin with the Theurgic Ritual of the Pentagram, cleansing and centering the working space. Open the gates in sequence according to the elemental rules and the order of the Celestial Pentagram. Invoke first the planetary ruler of the house in which your Sun is placed, and then the sign upon that house’s cusp. These invocations call forth the intelligence that governs the Sun’s ground of expression, rooting the cycle in the concrete sphere of life where your vitality is destined to unfold.</p>

                      <h3>Subsequent Days (one per day is suggested)</h3>
                      <p>From this point, you proceed through the remaining planets, one per day—Mercury, Venus, Moon, Mars, Jupiter, Saturn, Neptune, Uranus, and finally Pluto—each invoked in its exact natal sign and placement. Each day begins with the Celestial Pentagram Ritual, following the established rules for opening the gates. Then call the planetary intelligence first, and afterward its zodiacal sign, maintaining the proper sequence.</p>
                      {/* <ul>
                      <li>TRP → <span>Open gates</span> → Invoke <span>each planet in turn, in its natal sign and placement, from Mercury outward to Pluto (include the Moon according to your working order)</span>.</li>
                      <li>If including aspects, acknowledge major natal aspects <span> <i>between the day’s planet and previously installed bodies</i> </span> with a short harmonization line after the main call.</li>
                    </ul> */}

                      {/* <h3>Gate Rules (apply every day):</h3>
                    <ul>
                      <li> If <span>planet and sign share the same element (e.g., Neptune in Pisces)</span>, <span>open that elemental gate once</span>, then invoke <span>planet first, sign second</span>.</li>
                      <li> <span>If elements differ (e.g., Mars in Cancer)</span>, <span>open the planet’s elemental gate</span>, invoke the <span>planetary god</span>; then <span>open the sign’s elemental gate</span>, invoke the <span>zodiacal power</span>.</li>
                      <li>For stability with strong natal configurations, ground <span>all four directions</span> in the working element(s) before the first call of the pair.</li>
                    </ul> */}
                    </div>
                  </div>

                  <div className={stylesblk4.school_ritual_img_box_wrpr}>
                    <img
                      className={stylesblk4.school_ritual_img1}
                      src="/image/school_ritual_psd4_block20_mainWrp_bg_20aug.webp"
                      alt="Image"
                    />
                  </div>
                </div>
              </div>
            </div>
          </LazySection>

          {/* ---------------------------block24-------------------  */}

          <LazySection>
            <div
              className={`${stylesblk4.school_ritual_horoscope_mainWrp} ${stylesblk4.school_ritual_psd4_block24_mainWrp}`}
            >
              <div className={stylesblk4.common_width}>
                <div
                  className={`${stylesblk4.school_ritual_leo_wrpr} ${stylesblk4.flx_wrpr} ${stylesblk4.flx_row}`}
                >
                  <div className={stylesblk4.school_ritual_txt_box_wrpr}>
                    <div className={stylesblk4.school_ritual_txt_box_innr}>
                      <h2>Including Natal Transits in Complex Work</h2>
                      <p>
                        While the core of this rite is the re-animation of your natal pattern, advanced practitioners may also incorporate <span>active transits</span> as living extensions of the work. This is never part of the primary installation and should only be undertaken when there is sufficient time, stamina, and clarity of focus to sustain the expanded operation.
                      </p>

                      <p>
                        Transit invocations are structured through the development of <span>pronouncements</span>, crafted around the principle of the <span>prime</span> and the <span>secondary</span>. From among the transiting aspects, the theurgist discerns which planet calls most strongly to be the <span>prime</span>—the focal Intelligence to be invoked directly. Its counterpart in aspect then becomes the <span>secondary</span>, woven into the pronouncement to articulate the relationship.
                      </p>
                      <p>For example, with a transit of <span>Mars trine Saturn</span>, the theurgist may choose <span>Mars as prime</span>, since it is the planet to be directly invoked. After the prime is chosen, the invocation is written as a pronouncement that includes:</p>
                      <ul>
                        <li>1. The <span>aspectual language (trine, square, conjunction, etc.)</span>,</li>
                        <li>2. The <span>secondary planet</span> in its role,</li>
                        <li>3. The <span>signs</span> in which both planets presently reside.</li>
                      </ul>


                      <h3>
                        Example invocation:
                      </h3>
                      <p>
                        <span>“O Mars, blazing in Leo, I call you forth as prime in this working. Trine to Saturn in Sagittarius, fuse your fire with his measure, that my strength may be disciplined, and my action aligned to enduring order.”</span>
                      </p>

                      <p>
                        In practice, once the prime is determined, the elemental gate of its sign is opened, and the planetary invocation given with the crafted pronouncement. The secondary planet is not invoked separately but is integrated into the spoken call, ensuring that the living relationship of the aspect is embodied without dispersing the ritual focus.
                      </p>
                      <p>These pronouncements should be <span>concise, deliberate, and precise</span>. The natal sequence remains the spine of the rite, the fixed star-map of the soul. Transits are a <span>secondary weaving</span>, joining that natal pattern to the current motions of the heavens. Because they add both ceremonial duration and energetic demand, reserve them for configurations of genuine consequence in the year ahead. A fuller treatment of this method—including the structuring of primes, the integration of secondaries, and the role of zodiacal pronouncements—can be found in our section on <i>Manifestation and Divining the Future</i>.</p>


                    </div>
                  </div>

                  <div className={stylesblk4.school_ritual_img_box_wrpr}>
                    <img
                      className={stylesblk4.school_ritual_img1}
                      src="/image/school_ritual_psd4_block24_mainWrp_bg_20aug.webp"
                      alt="Image"
                    />
                  </div>
                </div>
              </div>
            </div>
          </LazySection>

          {/* ---------------------------block25-------------------  */}

          <LazySection>
            <div
              className={`${stylesblk4.school_ritual_horoscope_mainWrp} ${stylesblk4.school_ritual_psd4_block25_mainWrp}`}
            >
              <div className={stylesblk4.common_width}>
                <div
                  className={`${stylesblk4.school_ritual_leo_wrpr} ${stylesblk4.flx_wrpr} ${stylesblk4.flx_row}`}
                >
                  <div className={stylesblk4.school_ritual_txt_box_wrpr}>
                    <div className={stylesblk4.school_ritual_txt_box_innr}>
                      <h2>Effect of the Rite</h2>
                      {/* <ul>
                      <li><span> <strong>Planetary Responsiveness —</strong> </span> Your prior banishings and invocations ensure each god is personally known to you, responds to your call, and enters the ritual space without interference.</li>
                      <li><span> <strong>Zodiacal Coherence —</strong> </span> Your earlier sign work provides the structural stage and tempo for those gods to act through you without distortion or static.</li>
                      <li> <span> <strong>Clear Channels —</strong> </span> The Opening of the Gates keeps the elemental pathways unclouded so that the planetary currents transmit without refraction.</li>
                      <li> <span> <strong>Installed Seal —</strong> </span> Completing the full sequence during your Solar Return window enthrones your natal pattern as an active operating template for the year ahead — consciously aligned rather than passively carried.</li>
                      <h3>Frequency</h3>
                      <p>Undertake this at least once in your life; performing it yearly acts as a re-consecration of your place within the greater cosmic order. Some practitioners choose to perform a half-return review six months later, using a shortened version to refresh the alignment.</p>
                    </ul> */}
                      <p>To invoke the natal blueprint is to awaken the voice of the <span><i>oikeios daimōn</i></span>—the guardian spirit that has walked with you since the moment of your birth. In the rite, the chart ceases to be a map on paper and rises as a living presence, radiant and commanding, revealing the hidden symmetry between your soul and the heavens. The daimōn steps forward, not as an abstract idea, but as the intimate guide and double of your immortal self, drawing your awareness into direct union with the pattern through which you entered this life.</p>
                      <p>Each planetary intelligence, summoned in its rightful order, responds with clarity because its thread is woven into your very being. Each zodiacal sign resounds like a chamber of your own soul, giving body and rhythm to the gods as they act through you. The elements stand open as clear channels, transmitting the currents unbroken from their celestial source into your embodied form.</p>
                      <p>When the sequence is completed within the Solar Return, the natal seal is set upon you anew—not as something carried unconsciously, but as a consciously enthroned power. The year ahead opens as a field of divine responsiveness, where the gods act with you and through you, and where the guardian spirit speaks as the living center of your awareness.</p>

                      {/* <h3>
                      Phase V: Harmonization with Current Transits and the
                      Living Sky
                    </h3>
                    <p>
                      Once the natal pattern is activated and sanctified, we
                      turn our gaze to the heavens as they are now. We invoke
                      the current planetary transits, seeing them as living
                      invitations from the gods—opportunities to re-attune our
                      microcosm to the ever-unfolding macrocosmic rhythm. Each
                      transit is a present-moment activation of divine will; by
                      invoking them consciously, we harmonize with the unfolding
                      ritual of time itself.
                    </p>

                    <p>
                      Lastly, we invoke the zodiacal sign currently occupied by
                      the Sun—the solar gateway of the present month. This sign
                      becomes the active face of the Solar Logos, radiating its
                      unique quality of divine structuring into the world.
                      Through this monthly invocation, we synchronize our
                      theurgical work with the natural calendar of the heavens,
                      allowing our soul to move in concert with the great wheel
                      of becoming.
                    </p>

                    <p>
                      In this way, the practice of Astrological Theurgy unfolds
                      not as a mechanical formula, but as a sacred choreography
                      of invocation and divine participation. The stars and
                      planets are not tools but beings—not influences but
                      intelligences. Through banishment, purification,
                      invocation, and alignment, we take our place once more in
                      the cosmic liturgy. We do not merely trace the patterns of
                      the heavens—we become them. This is the heart of theurgic
                      embodiment: to take the shape of the gods, not in fantasy
                      but in reality.
                    </p>
                    <p>
                      What follows are the precise instructions and formulas for
                      carrying out this ritual sequence, in accordance with the
                      divine order that governs both the heavens and the soul.
                    </p> */}
                    </div>
                  </div>

                  <div className={stylesblk4.school_ritual_img_box_wrpr}>
                    <img
                      className={stylesblk4.school_ritual_img1}
                      src="/image/school_ritual_psd4_block25_mainWrp_bg_20aug_new.webp"
                      alt="Image"
                    />
                  </div>
                </div>
              </div>
            </div>
          </LazySection>
        </div>
      </div>
    </>
  )
}

export default BlockSeven

